/// <amd-module name="Search/Code/Components/ItemContextualMenu" />

import * as React from "react";
import * as Resources from "Search/Code/Resources";
import { MenuButton, IMenuItem } from "VSSUI/Menu";
import { getCommandsInContextMenu, ICommandsOptions } from "Search/Code/Components/ItemCommands";
import { CodeResult } from "Search/LegacyWebApi/Contracts/Code";
import { Location } from "VSSUI/Utilities/Position";

export interface IItemRowContextualMenuButtonProps {
    item: CodeResult;

    itemUrl: string | undefined;

    onMenuItemInvoked?: (item: IMenuItem) => void;
}

export const ItemRowContextualMenuButton = (props: IItemRowContextualMenuButtonProps) => {
    return (
        <span className="search-context-menu-container">
            <MenuButton
                hideDropdownIcon={true}
                className="context-menu-button"
                contextualMenuProps={{
                    anchorOrigin: { horizontal: Location.start, vertical: Location.end },
                    menuOrigin: { horizontal: Location.start, vertical: Location.start},
                    menuProps: {
                        id: "code-result-actions",
                        items: getCommandsInContextMenu(props as ICommandsOptions)
                    }
                }}
                iconProps={{ iconName: "More", className: "more-icon" }}
                tooltipProps={{ text: Resources.MoreActionsTooltip }} />
        </span>
    );
}